import PropTypes from "prop-types";
import i18next from "i18next";

export const AddressPopupPropTypes = {
    labels: PropTypes.shape({
        title: PropTypes.string,
        singleOrder: PropTypes.string,
        groupOrder: PropTypes.string,
        pickup: PropTypes.string,
        delivery: PropTypes.string,
        save: PropTypes.string,
        zipPlaceholder: PropTypes.string,
        locPlaceholder: PropTypes.string,
        warningTitle: PropTypes.string,
        warning: PropTypes.string,
        notifyMe: PropTypes.string,
        newAddress: PropTypes.string,
        pickStore: PropTypes.string,
        forcePickupTitle: PropTypes.string,
        noHouseNumberError: PropTypes.string,
        zipcodeWarning: PropTypes.string,
        goToPickup: PropTypes.string,
        goToDelivery: PropTypes.string,
        startGroupOrder: PropTypes.string,
    }),
    suggestions: PropTypes.array,
    setLocationQuery: PropTypes.func,
    pickupAreas: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
                .isRequired,
            name: PropTypes.string,
        })
    ),
    forcePickup: PropTypes.bool,
    setOpen: PropTypes.func,
    setForcePickup: PropTypes.func,
    onAddressSelect: PropTypes.func,
    submitData: PropTypes.func,
    forceSelection: PropTypes.bool,
    checkPlaceDetails: PropTypes.func,
    noHouseNumberError: PropTypes.bool,
    forceOnGroupOrder: PropTypes.oneOfType([PropTypes.any, PropTypes.string]),
    startGroupOrder: PropTypes.func,
    tab: PropTypes.string,
    setTab: PropTypes.func,
    openTab: PropTypes.string,
};

export const AddressPopupLabels = {
    title: i18next.t("addressPopup.title"),
    singleOrder: i18next.t("addressPopup.singleOrder"),
    groupOrder: i18next.t("addressPopup.groupOrder"),
    pickup: i18next.t("addressPopup.pickup"),
    delivery: i18next.t("addressPopup.delivery"),
    save: i18next.t("addressPopup.save"),
    zipPlaceholder: i18next.t("addressPopup.zipPlaceholder"),
    locPlaceholder: i18next.t("addressPopup.locPlaceholder"),
    warningTitle: i18next.t("addressPopup.warningTitle"),
    warning: i18next.t("addressPopup.warning"),
    notifyMe: i18next.t("addressPopup.notifyMe"),
    newAddress: i18next.t("addressPopup.newAddress"),
    pickStore: i18next.t("addressPopup.pickStore"),
    forcePickupTitle: i18next.t("addressPopup.forcePickupTitle"),
    noHouseNumberError: i18next.t("addressPopup.noHouseNumberError"),
    zipcodeWarning: i18next.t("addressPopup.zipcodeWarning"),
    goToPickup: i18next.t("addressPopup.goToPickup"),
    goToDelivery: i18next.t("addressPopup.goToDelivery"),
    startGroupOrder: i18next.t("addressPopup.startGroupOrder"),
};
